import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import type { Breadcrumb } from '@/types/shared'
import { Form, type ParticipantOption, type PracticeMatchFormValues } from './components/Form'

type Props = {
  practiceMatch: PracticeMatchFormValues
  options: { teams: ParticipantOption[]; schools: ParticipantOption[] }
  breadcrumbs: Breadcrumb[]
}

export default function New({ practiceMatch, options, breadcrumbs }: Props) {
  return (
    <AppShell>
      <Head title="練習試合の新規登録" />
      <PageHeader
        title="練習試合の新規登録"
        description="クラブチーム同士または高校同士の練習試合を登録します。"
        breadcrumbs={breadcrumbs}
      />
      <Form values={practiceMatch} teams={options.teams} schools={options.schools} mode="create" />
    </AppShell>
  )
}
